/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-danger */
import React, { Fragment, useEffect, useState } from 'react';
import {
  Row,
  Collapse,
  Card,
  Button,
  NavItem,
  Nav,
  TabContent,
  TabPane,
  CardBody,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from 'reactstrap';
import {
  Separator,
  Colxx,
} from '../../../../components/common/CustomBootstrap';
import FAQList from './Components/FAQList';
import FAQForm from './Components/FAQForm';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import {
  API_FAQ,
  API_FAQ_Collection,
  postAPI_Business_Operator_PublishGPT,
} from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Logs from './Components/Logs';
import Validation from '../../../../components/Validation';
import { NotificationManager } from '../../../../components/common/react-notifications';
import no_faq from './../../../../assets/no_faq.png';
import no_collection from './../../../../assets/collection.png';
import FAQCollection from './Components/FAQCollectionForm';
import FAQCollectionList from './Components/FAQCollectionList';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder, faFilter } from '@fortawesome/free-solid-svg-icons';
const style_css = `.nav-tabs .nav-link.active::before,.nav-tabs .nav-item.show .nav-link::before {
    top:auto !important;
    bottom: 0 !important;
  }
  .active{
    background-color:transparent;
  }`;

const Faq = ({ match, propertyId, locale, email }) => {
  const [open, setOpen] = useState(false);
  const [totalFAQ, setTotalFAQ] = useState([]);
  const [activeTab, setActiveTab] = useState('FAQ');
  const [msg, setMsg] = useState([]);
  const [createFaq, setCreateFaq] = useState(false);
  const [collection, setCollection] = useState('All');
  const [status, setStatus] = useState('All');
  const [createFAQCollection, setCreateFAQCollection] = useState(false);
  const [showLogs, setShowLogs] = useState(false);
  const [search, setSearch] = useState('');
  const handleToggle = () => {
    setCreateFaq(!createFaq);
  };

  const [faqList, setFAQList] = useState([]);
  const [faqCollectionList, setFAQCollectionList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    pii: false,
    confidentiality: false,
    harmfulfree: false,
  });
  const [isFormValid, setIsFormValid] = useState(false);
  useEffect(() => {
    if (activeTab === 'FAQ') LoadData();
    else LoadCollection();
  }, [search, activeTab, collection, status]);

  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${API_FAQ}/list?groupId=${getGroupID()}&propertyId=${propertyId}&locale=${locale}&search=${search}&collection=${collection}&status=${status}`,
    }).then((res) => {
      setFAQList(res.data);
      setTotalFAQ(res.data);
    });
    LoadCollection();
  }, [propertyId]);

  const handleTotalFAQ = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_FAQ}/list?groupId=${getGroupID()}&propertyId=${propertyId}&locale=${locale}&search=${search}&collection=&status=`,
    }).then((res) => {
      setTotalFAQ(res.data);
    });
  };

  const handleShowLogs = () => {
    setShowLogs(!showLogs);
  };

  const LoadCollection = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_FAQ_Collection}/list?groupId=${getGroupID()}&propertyId=${propertyId}`,
    }).then((res) => {
      setFAQCollectionList(res.data);
    });
  };
  const LoadData = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_FAQ}/list?groupId=${getGroupID()}&propertyId=${propertyId}&locale=${locale}&search=${search}&collection=${collection}&status=${status}`,
    }).then((res) => {
      setFAQList(res.data);
    });
  };
  const handleAddFAQ = (inputData) => {
    AxiosAPI({
      method: 'post',
      url: API_FAQ,
      data: inputData,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        LoadData();
        handleTotalFAQ();
        handleToggle();
      }
    });
  };

  const handleAddFAQCollection = (inputData) => {
    AxiosAPI({
      method: 'post',
      url: API_FAQ_Collection,
      data: inputData,
    }).then((res) => {
      if (
        res.data.HttpStatusCode !== undefined &&
        res.data.HttpStatusCode === 400 &&
        res.data.Messages !== undefined &&
        res.data.Messages !== null &&
        res.data.Messages.length > 0
      ) {
        setMsg(res.data.Messages);
        setOpen(true);
      } else {
        LoadCollection();
        setCreateFAQCollection(!createFAQCollection);
      }
    });
  };
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxes((prev) => {
      const updatedCheckboxes = { ...prev, [name]: checked };
      setIsFormValid(
        updatedCheckboxes.pii &&
        updatedCheckboxes.confidentiality &&
        updatedCheckboxes.harmfulfree
      );
      return updatedCheckboxes;
    });
  };

  const handlePublish = () => {
    var body = {
      GroupId: getGroupID(),
      PropertyId: propertyId,
      Language: locale === 'en' ? 'en-US' : locale,
      email: email,
      version: 3,
      type: 0,
      Creator: 'dashboard',
    };
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Business_Operator_PublishGPT}`,
      data: body,
    }).then(() =>
      NotificationManager.success(
        '',
        'We have received your request. Publish will take few minutes.',
        3000,
        null,
        null,
        'success'
      )
    );
    toggleModal();
  };

  const onSearchKey = (e) => {
    if (e.key === 'Enter') {
      setSearch(e.target.value.toLowerCase());
    }
  };

  return (
    <Fragment>
      <Row>
        <Colxx xxs={activeTab === 'FAQ' ? '10' : '12'}>
          <Nav tabs className="card-header-tabs separator-tabs mb-3 ml-2 mr-0">
            <style>{style_css}</style>
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: activeTab === 'FAQ',
                  'nav-link': true,
                })}
                onClick={() => {
                  setActiveTab('FAQ');
                }}
                to="#"
              >
                <span
                  style={{
                    color: `${activeTab === 'FAQ' ? 'var(--theme-color-1)' : '#8f8f8f'
                      }`,
                  }}
                >
                  FAQs
                </span>
              </NavLink>
            </NavItem>
            <NavItem
              className="text-center"
              style={{ width: 'auto', background: '' }}
            >
              <NavLink
                style={{ background: 'none', cursor: 'pointer' }}
                className={classnames({
                  active: activeTab === 'collection',
                  'nav-link': true,
                })}
                onClick={() => {
                  setActiveTab('collection');
                }}
                to="#"
              >
                {' '}
                <span
                  style={{
                    color: `${activeTab === 'collection'
                        ? 'var(--theme-color-1)'
                        : '#8f8f8f'
                      }`,
                  }}
                >
                  Collections
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab} className="">
            <TabPane tabId="FAQ" className="chat-app-tab-pane">
              <Row className="mt-3">
                <Colxx xxs="12" className="mb-0">
                  <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                    <input
                      type="text"
                      name="keyword"
                      id="search"
                      placeholder="Search"
                      onKeyPress={(e) => onSearchKey(e)}
                    />
                  </div>
                  <Button
                    size="xs"
                    outline
                    className=""
                    onClick={handleToggle}
                    color="primary"
                  >
                    {' '}
                    + Add FAQ
                  </Button>
                  <Button
                    size="xs"
                    outline
                    className="ml-2"
                    color="primary"
                    onClick={handleShowLogs}
                  >
                    Change Log
                  </Button>
                  {/* <Button size="xs" outline className='ml-2' color='primary' onClick={toggleModal}>Publish GPT</Button > */}
                  <a href="/app/pages/propinfo/publish-ai">
                    <Button color="primary" outline size="xs">
                      Publish AI
                    </Button>
                  </a>
                </Colxx>
                <Colxx xxs="12" className="mb-2 text-right">
                  <strong>
                    <hr />
                  </strong>
                </Colxx>
              </Row>
              {faqList !== undefined && faqList.length > 0 ? (
                <Fragment>
                  <Colxx xxs="12" className="mb-4">
                    <FAQList
                      faqCollectionList={faqCollectionList}
                      handleTotalFAQ={handleTotalFAQ}
                      show
                      LoadData={LoadData}
                      faqList={faqList}
                    ></FAQList>
                  </Colxx>
                </Fragment>
              ) : (
                <Colxx xxs="12" className="mb-4 text-center">
                  <img
                    className="w-25"
                    style={{ marginTop: '5rem' }}
                    src={no_faq}
                  ></img>
                </Colxx>
              )}

              {createFaq && (
                <FAQForm
                  faqCollectionList={faqCollectionList}
                  label={'Create FAQ'}
                  toggle={handleToggle}
                  submit={handleAddFAQ}
                  visible={createFaq}
                ></FAQForm>
              )}

              {showLogs && (
                <Logs
                  label={'FAQ Logs'}
                  toggle={handleShowLogs}
                  visible={showLogs}
                  logType="FAQ"
                ></Logs>
              )}
            </TabPane>
            <TabPane tabId="collection" className="chat-app-tab-pane">
              <Row className="mt-3">
                <Colxx xxs="12" className="mb-0">
                  {/* <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                                        <input
                                            type="text"
                                            name="keyword"
                                            id="search"
                                            placeholder="Search"
                                            onKeyPress={(e) => onSearchKey(e)}
                                        />
                                    </div> */}
                  <Button
                    size="xs"
                    outline
                    className=""
                    onClick={() => setCreateFAQCollection(!createFAQCollection)}
                    color="primary"
                  >
                    {' '}
                    + Add Collection
                  </Button>
                </Colxx>
                <Colxx xxs="12" className="mb-2 text-right">
                  <strong>
                    <hr />
                  </strong>
                </Colxx>
              </Row>
              {faqCollectionList !== undefined &&
                faqCollectionList.length > 0 ? (
                <Colxx xxs="12" className="mb-4">
                  <FAQCollectionList
                    show
                    LoadData={LoadCollection}
                    faqCollectionList={faqCollectionList}
                  ></FAQCollectionList>
                </Colxx>
              ) : (
                <Colxx xxs="12" className="mb-4 text-center">
                  <img
                    className="w-25"
                    style={{ marginTop: '5rem' }}
                    src={no_collection}
                  ></img>
                </Colxx>
              )}

              {createFAQCollection && (
                <FAQCollection
                  label={'Create Collection'}
                  toggle={() => setCreateFAQCollection(!createFAQCollection)}
                  submit={handleAddFAQCollection}
                  visible={createFAQCollection}
                ></FAQCollection>
              )}
            </TabPane>
          </TabContent>
        </Colxx>
        {activeTab === 'FAQ' && (
          <Colxx xxx="2" className="app-menu">
            <Row className="m-2">
              <Colxx xxs="6 mt-4">
                <h6>
                  {' '}
                  <i
                    className="iconsminds-filter-2 mr-2"
                    style={{ color: 'var(--theme-color-1)' }}
                  />{' '}
                  Status
                </h6>
              </Colxx>
              <Colxx xxs="8" className="text-left ml-1">
                <CustomInput
                  type="radio"
                  id={'All FAQs'}
                  name={'FAQs'}
                  label={'All FAQs'}
                  checked={status === 'All'}
                  onChange={(event) => setStatus('All')}
                />
              </Colxx>
              <Colxx xxs="3" className="text-right">
                {
                  totalFAQ.filter(
                    (f) =>
                      f.status === 'Draft' ||
                      f.status === 'Published' ||
                      f.status === 'ReadyToPublish'
                  ).length
                }
              </Colxx>
              <Colxx xxs="8" className="text-left ml-1">
                <CustomInput
                  type="radio"
                  id={'Draft'}
                  name={'Draft'}
                  label={'In Draft'}
                  checked={status === 'Draft'}
                  onChange={(event) => setStatus('Draft')}
                />
              </Colxx>
              <Colxx xxs="3" className="text-right">
                {totalFAQ.filter((f) => f.status === 'Draft').length}
              </Colxx>
              <Colxx xxs="8" className="text-left ml-1">
                <CustomInput
                  type="radio"
                  id={'ReadyToPublish'}
                  name={'ReadyToPublish'}
                  label={'Ready To Publish'}
                  checked={status === 'ReadyToPublish'}
                  onChange={(event) => setStatus('ReadyToPublish')}
                />
              </Colxx>
              <Colxx xxs="3" className="text-right">
                {totalFAQ.filter((f) => f.status === 'ReadyToPublish').length}
              </Colxx>
              <Colxx xxs="8" className="text-left ml-1">
                <CustomInput
                  type="radio"
                  id={'Published'}
                  name={'Published'}
                  label={'Published'}
                  checked={status === 'Published'}
                  onChange={(event) => setStatus('Published')}
                />
              </Colxx>
              <Colxx xxs="3" className="text-right">
                {totalFAQ.filter((f) => f.status === 'Published').length}
              </Colxx>
            </Row>
            <Row className="m-2">
              <Colxx xxs="12 mt-4">
                <h6>
                  {' '}
                  <i
                    className="iconsminds-folders mr-2"
                    style={{ color: 'var(--theme-color-1)' }}
                  />{' '}
                  Collections
                </h6>
              </Colxx>
              <Colxx xxs="8" className="text-left ml-1">
                <CustomInput
                  type="radio"
                  id={'All'}
                  name={'All'}
                  label={'All Collections'}
                  checked={collection === 'All'}
                  onChange={(event) => setCollection('All')}
                />
              </Colxx>
              <Colxx xxs="3" className="text-right">
                {totalFAQ.length}
              </Colxx>
              {faqCollectionList !== undefined &&
                faqCollectionList.length > 0 ? (
                faqCollectionList.map((m) => (
                  <Fragment>
                    <Colxx xxs="8" className="text-left  ml-1">
                      <CustomInput
                        type="radio"
                        id={m.id}
                        name={m.title}
                        label={m.title}
                        checked={collection === m.id}
                        onChange={(event) => {
                          setCollection(m.id);
                        }}
                      />
                    </Colxx>
                    <Colxx xxs="3" className="text-right">
                      {totalFAQ.filter((f) => f.collection === m.id).length}
                    </Colxx>
                  </Fragment>
                ))
              ) : (
                <Fragment>
                  <Colxx xxs="12" className="text-left my-2">
                    <b>
                      The first step for organizing your FAQs is to organize
                      them into distinct Collections. Think of Collections as a
                      folder in your computer.
                    </b>
                  </Colxx>
                  <Colxx xxs="12" className="text-left">
                    <Button
                      size="xs"
                      outline
                      className=""
                      onClick={() =>
                        setCreateFAQCollection(!createFAQCollection)
                      }
                      color="primary"
                    >
                      {' '}
                      + Add Collection
                    </Button>
                  </Colxx>
                </Fragment>
              )}
            </Row>
          </Colxx>
        )}
      </Row>
      <Validation
        open={open}
        messages={msg}
        toggle={() => {
          setOpen(!open);
        }}
      ></Validation>
    </Fragment>
  );
};

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Faq));
